<template>
  <div class="body">
    <headers></headers>
    <div class="cons">
      <div class="cons_username">
        <div class="cons_pople">
          <p class="cons_pople_pic">
            <img src="@/assets/home_user.png" />
          </p>
          <p class="cons_pople_online">在线人数</p>
          <p class="cons_pople_onlineSum">{{count_pople}}</p>
        </div>
        <div class="cons_catenate">
          <p class="cons_catenate_pic">
            <img src="@/assets/home_catenation.png" />
          </p>
          <p class="cons_catenate_online">连接状态</p>
          <p class="cons_catenate_onlineSum">正常</p>
          <p class="cons_catenate_relink" v-if="false">
            <img src="@/assets/reLink.png" />重新连接
          </p>
        </div>
      </div>
      <div class="cons_deed">
        <template>
          <el-tabs v-model="activeName" @tab-click="handleClick()">
            <el-tab-pane label="员工概况" name="yggk"></el-tab-pane>
            <el-tab-pane label="历史记录" name="lsjl">
              <div class="tab_lsjl">
                <div v-on:click="onLsjl('lx')" :class="[classet == 'lx' ? 'on' : '']">
                  <img src="@/assets/ls_icon1.png" />录像
                </div>
                <div v-on:click="onLsjl('jt')" :class="[classet == 'jt' ? 'on' : '']">
                  <img src="@/assets/ls_icon2.png" />截图
                </div>
                <div v-on:click="onLsjl('lt')" :class="[classet == 'lt' ? 'on' : '']">
                  <img src="@/assets/ls_icon3.png" />聊天
                </div>
                <div v-on:click="onLsjl('wj')" :class="[classet == 'wj' ? 'on' : '']">
                  <img src="@/assets/ls_icon4.png" />文件
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="行为审计" name="xwsj">
              <div class="tab_lsjl">
                <div v-on:click="onXwsj('wz')" :class="[classet == 'wz' ? 'on' : '']">
                  <img src="@/assets/xw_icon1.png" />网址记录
                </div>
                <div v-on:click="onXwsj('rj')" :class="[classet == 'rj' ? 'on' : '']">
                  <img src="@/assets/xw_icon2.png" />软件记录
                </div>
                <div v-on:click="onXwsj('jq')" :class="[classet == 'jq' ? 'on' : '']">
                  <img src="@/assets/xw_icon3.png" />剪切板
                </div>
                <div v-on:click="onXwsj('kg')" :class="[classet == 'kg' ? 'on' : '']">
                  <img src="@/assets/xw_icon4.png" />开关机
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="实时监控" name="ssjk">
              <div class="tab_lsjl">
                <div v-on:click="onSsjk('pm')" :class="[classet == 'pm' ? 'on' : '']">
                  <img src="@/assets/sj_icon1.png" />屏幕监控
                </div>
                <div v-on:click="onSsjk('dp')" :class="[classet == 'dp' ? 'on' : '']">
                  <img src="@/assets/sj_icon2.png" />多屏监控
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="系统消息" name="xtxx">
              <div class="tab_lsjl">
                <div v-on:click="onXtxx('jc')" :class="[classet == 'jc' ? 'on' : '']">
                  <img src="@/assets/xt_icon1.png" />进程信息
                </div>
                <div v-on:click="onXtxx('xt')" :class="[classet == 'xt' ? 'on' : '']">
                  <img src="@/assets/xt_icon2.png" />系统服务
                </div>
                <div v-on:click="onXtxx('rj')" :class="[classet == 'rj' ? 'on' : '']">
                  <img src="@/assets/xt_icon3.png" />软件列表
                </div>
                <div v-on:click="onXtxx('yj')" :class="[classet == 'yj' ? 'on' : '']">
                  <img src="@/assets/xt_icon4.png" />硬件列表
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
      <div class="cons_group">
        <div style="padding:0 25px;">
          <div class="cons_group_header">
            <div
              class="cons_addGroup"
              v-on:mouseover="addGruopOver()"
              v-on:mouseout="addGruopOut()"
              v-on:click="GruopClick('add',null)"
            >
              <img :src="addGroup" />添加分组
            </div>
            <div class="cons_online" v-on:click="onlineClick()">
              <img :src="online" />只显示在线
            </div>
          </div>
          <div class="cons_group_con" style="display:flex">
            <template>
              <el-select
                v-model="value"
                placeholder="请选择"
                @change="optionsChange($event)"
                style="width:300px"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.group_name + '('+ item.taishu +')'"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
            <i
              class="el-icon-edit-outline"
              style="font-size:20px;margin-top:10px;cursor: pointer;margin-left:15px"
              :style="{'color':cursonGroup == 8 ? 'gray':'rgba(40,120,255,1)'}"
              @click="updategroup()"
            ></i>
            <i
              class="el-icon-delete"
              style="font-size:20px;margin-top:10px;cursor: pointer;margin-left:15px"
              :style="{'color':cursonGroup == 8 ? 'gray':'rgba(40,120,255,1)'}"
              @click="deletegroup()"
            ></i>
          </div>
          <div class="cons_group_footer">
            <ul>
              <li
                v-for="item in poples"
                :key="item.id"
                v-on:mouseover="onLiOver($event,item)"
                v-on:click="ygInfo(item)"
                :class="item.click == true ? 'on' : ''"
              >
                <span>
                  <label v-if="item.is_online == 1">
                    <img src="@/assets/pc_on.png" />
                  </label>
                  <label v-if="item.is_online == 0">
                    <img src="@/assets/pc_off.png" />
                  </label>
                  {{item.user_name}}
                </span>
                <el-dropdown v-if="item.check == true" placement="bottom-start">
                  <span
                    class="el-dropdown-link"
                    v-on:mouseover="onUpdateOver()"
                    v-on:mouseout="onUpdateOut()"
                    @click.stop
                  >
                    <img :src="update" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item style="padding:0 0">
                      <label
                        style="display:inline-block;width:100%;cursor:pointer;padding:0 20px;"
                        v-on:click="GruopClick('update',item)"
                      >编辑名称</label>
                    </el-dropdown-item>
                    <el-dropdown-item style="padding:0 0">
                      <label
                        style="display:inline-block;width:100%;cursor:pointer;padding:0 20px;"
                        v-on:click="GruopClick('delete',item)"
                      >卸载员工端</label>
                    </el-dropdown-item>
                    <el-dropdown-item style="padding:0 0">
                      <label
                        style="display:inline-block;width:100%;cursor:pointer;padding:0 20px;"
                        v-on:click="GruopClick('move',item)"
                      >移动到分组</label>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--  欢迎界面  -->
      <div class="cons_content">
        <router-view></router-view>
      </div>
      <!--  员工概况  -->
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="350px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="wxts_close" v-on:click="onClose()">x</div>
      <div class="wxts">
        <p class="p_wxp1">
          <img src="@/assets/prompt.png" />温馨提示
        </p>
        <p class="p_wxp2">请选择左侧要查看的电脑对象。</p>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="GroupVisible"
      width="350px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="wxts_close" v-on:click="onGronpClose()">x</div>
      <h3>{{group_tit}}</h3>
      <div style="margin-top:20px;">
        <el-input
          v-model="addGroupValue"
          placeholder="请输入内容"
          v-if="this.group_state != 'move'"
          style="width:200px"
        ></el-input>
        <el-select
          v-model="gronpValue"
          placeholder="请选择"
          v-if="this.group_state == 'move'"
          style="width:200px"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.group_name"
            :value="item.group_name"
          ></el-option>
        </el-select>
        <el-button type="primary" style="margin-left:8px;" v-on:click="addGroupOk()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import headers from "./general/header";
import { http } from "./../https";
export default {
  components: {
    headers: headers
  },
  data() {
    return {
      /** 在线人数 */
      count_pople: 0,
      activeName: "second",
      addGroup: require("@/assets/home_addGroup.png"),
      online: require("@/assets/home_online.png"),
      update: require("@/assets/update.png"),
      value: "未分组",
      gronpValue: "",
      options: [],
      poples: [],
      dialogVisible: false,
      GroupVisible: false,
      GroupData: {},
      addGroupValue: "",
      group_tit: "",
      group_state: "",
      mac: "",
      classet: "",
      datas: [],
      ryCheck: false,
      onlineBool: false,
      jsonqb: [],
      cursonGroup: 8,
      oldName: "",
      types: 0
    };
  },
  created() {
    if (window.sessionStorage.getItem("oauth_token") === null) {
      this.$router.push("/login");
    }
    const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
    let is = false;
    for (let e of dataGroup.group) {
      if (e.id == 8) {
        is = true;
      }
    }
    if (!is) {
      dataGroup.group.push({
        group_name: "未分组",
        id: "8",
        owner: "nmtest1034"
      });
    }
    sessionStorage.setItem("dataGroup", JSON.stringify(dataGroup));
    this.global.ws.onmessage = params => {
      let data = JSON.parse(params.data);
      console.log(data);
      switch (data.type) {
        case 1:
          this.ping();
          break;
        case 24:
          this.menberOn(data);
          break;
        case 25:
          this.menberOff(data);
          break;
      }
    };
    this.groupList();
    this.getpople();
    this.routes();
    this.LoginMenberinfo();
  },
  methods: {
    /** 获取当前路由 */
    routes() {
      if (this.$route.path == "/yggk") {
        this.activeName = "yggk";
      } else if (
        this.$route.path == "/lsjl_lx" ||
        this.$route.path == "/lsjl_jt" ||
        this.$route.path == "/lsjl_lt" ||
        this.$route.path == "/lsjl_wj"
      ) {
        this.activeName = "lsjl";
      } else if (
        this.$route.path == "/xwsj_wz" ||
        this.$route.path == "/xwsj_rj" ||
        this.$route.path == "/xwsj_jq" ||
        this.$route.path == "/xwsj_kg"
      ) {
        this.activeName = "xwsj";
      } else if (
        this.$route.path == "/ssjk_pm" ||
        this.$route.path == "/ssjk_dp"
      ) {
        this.activeName = "ssjk";
      } else if (
        this.$route.path == "/xtxx_jc" ||
        this.$route.path == "/xtxx_xt" ||
        this.$route.path == "/xtxx_rj" ||
        this.$route.path == "/xtxx_xx"
      ) {
        this.activeName = "xtxx";
      }
      this.classet = this.$route.path.substring(this.$route.path.length - 2);
    },
    /** 展开登录员工信息 */
    LoginMenberinfo() {},
    /** 监听当前 */
    ping() {
      if (this.global.ws.readyState === 1) {
        this.global.ws.send('{"type":1}');
      } else {
        this.global.ws.onopen = () => {
          this.global.ws.send('{"type":1}');
        };
      }
    },
    /** 员工上线 */
    menberOn(params) {
      let s = 0;
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      this.poples.forEach(item => {
        if (item.peerId == params.data.peerId) {
          item.is_online = 1;
          item.mac = params.data.mac;
          item.ip = params.data.ip;
          s = 1;
        }
      });
      if (s == 0) {
        this.poples.push(params.data);
      }
      dataGroup.server.forEach(item => {
        if (item.peerId == params.data.peerId) {
          item.is_online = 1;
          item.mac = params.data.mac;
          item.ip = params.data.ip;
        }
      });
      this.paixu(this.poples);
      sessionStorage.setItem("dataGroup", JSON.stringify(dataGroup));
      this.getpople();
    },
    /** 员工下线 */
    menberOff(params) {
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      this.poples.forEach(item => {
        if (item.peerId == params.data.peerId) {
          item.is_online = 0;
        }
      });
      dataGroup.server.forEach(item => {
        if (item.peerId == params.data.peerId) {
          item.is_online = 0;
        }
      });
      this.paixu(this.poples);
      sessionStorage.setItem("dataGroup", JSON.stringify(dataGroup));
      this.getpople();
    },
    /** 编辑分组 */
    updategroup() {
      if (this.cursonGroup == 8) {
        return false;
      }
      this.group_tit = "编辑分组名";
      this.group_state = "updateGroupName";
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      for (let i = 0; i < dataGroup.group.length; i++) {
        if (dataGroup.group[i].id == this.cursonGroup) {
          this.oldName = dataGroup.group[i].group_name;
        }
      }
      this.addGroupValue = this.oldName;
      this.GroupVisible = true;
    },
    /** 删除分组 */
    deletegroup() {
      if (this.cursonGroup == 8) {
        return false;
      }
      this.$confirm("此操作将永久删除分组, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const user_name = sessionStorage.getItem("user_name");
          const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
          let name = "";
          for (let ds of dataGroup.group) {
            if (ds.id == this.cursonGroup) {
              name = ds.group_name;
            }
          }
          let json = {
            user: user_name,
            type: 8,
            group_name: name
          };
          if (this.global.ws.readyState === 1) {
            this.global.ws.send(JSON.stringify(json));
          } else {
            this.global.ws.onopen = () => {
              this.global.ws.send(JSON.stringify(json));
            };
          }
          this.global.ws.onmessage = params => {
            let data = JSON.parse(params.data);
            if (data.code == 0) {
              let names = "";
              for (let i = 0; i < dataGroup.group.length; i++) {
                if (dataGroup.group[i].id == this.cursonGroup) {
                  names = dataGroup.group[i].group_name;
                  dataGroup.group.splice(i, 1);
                }
              }
              for (let q of dataGroup.server) {
                if (q.group_name == names) {
                  q.group_name = "未分组";
                }
              }
              sessionStorage.setItem("dataGroup", JSON.stringify(dataGroup));
              this.groupList();
              this.value = "未分组";
              this.optionsChange(8);
              this.$message({ message: "删除成功", type: "success" });
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: "error"
              });
            }
          };
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    /** 获取分组信息 */
    groupList() {
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      this.options = dataGroup.group;
      this.optionsChange(8);
    },
    /** 排序 */
    paixu(josns) {
      let json = [];
      for (let s of josns) {
        if (s.is_online == "1") {
          json.push(s);
        }
      }
      for (let s of josns) {
        if (s.is_online == "0") {
          json.push(s);
        }
      }
      this.poples = json;
    },
    /** 获取在线人数 */
    getpople() {
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      this.count_pople = 0;
      for (let s of dataGroup.server) {
        if (s.is_online == "1") {
          this.count_pople++;
        }
      }
    },
    addGruopOver() {
      this.addGroup = require("@/assets/home_addGroup_hover.png");
    },
    addGruopOut() {
      this.addGroup = require("@/assets/home_addGroup.png");
    },
    onUpdateOver() {
      this.update = require("@/assets/update_hover.png");
    },
    onUpdateOut() {
      this.update = require("@/assets/update.png");
    },
    optionsChange(e) {
      this.cursonGroup = e;
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      console.log(dataGroup);
      let name = "";
      dataGroup.group.forEach(item => {
        if (item.id == e) {
          name = item.group_name;
        }
      });
      for (let s of dataGroup.server) {
        s["check"] = false;
      }
      for (let s of dataGroup.server) {
        s["click"] = false;
      }
      let json = [];
      if (this.onlineBool) {
        dataGroup.server.forEach(item => {
          if (item.is_online == 1) {
            if (item.group_name == name) {
              json.push(item);
            }
          }
        });
        if (name != "未分组") {
          this.value = name + "(" + json.length + ")";
        }
        let d = 0;
        for (let dow of this.options) {
          dow["taishu"] = 0;
          for (let don of dataGroup.server) {
            if (don.is_online == 1) {
              if (dow.group_name == don.group_name) {
                if (dow.group_name == "未分组") {
                  d++;
                }
                dow["taishu"]++;
              }
            }
            if (e == 8) {
              this.value = "未分组(" + d + ")";
            }
          }
        }
        this.paixu(json);
      } else {
        dataGroup.server.forEach(item => {
          if (item.group_name == name) {
            json.push(item);
          }
        });
        if (name != "未分组") {
          this.value = name + "(" + json.length + ")";
        }
        let d = 0;
        for (let dow of this.options) {
          dow["taishu"] = 0;
          for (let don of dataGroup.server) {
            if (dow.group_name == don.group_name) {
              if (dow.group_name == "未分组") {
                d++;
              }
              dow["taishu"]++;
            }
          }
          if (e == 8) {
            this.value = "未分组(" + d + ")";
          }
        }
      }
      this.paixu(json);
    },
    onlineClick() {
      if (!this.onlineBool) {
        this.online = require("@/assets/home_online_hover.png");
        let json = [];
        this.jsonqb = [];
        this.poples.forEach(item => {
          if (item.is_online == "1") {
            this.jsonqb.push(item);
            json.push(item);
          } else {
            this.jsonqb.push(item);
          }
        });
        this.poples = json;
      } else {
        this.online = require("@/assets/home_online.png");
        this.poples = this.jsonqb;
      }
      this.onlineBool = !this.onlineBool;
      this.optionsChange(this.cursonGroup);
    },
    GruopClick(e, data) {
      this.group_state = e;
      this.GroupData = data;
      if (e == "add") {
        this.addGroupValue = "";
        this.group_tit = "添加分组";
        //this.gronpValue = data
        this.GroupVisible = true;
      } else if (e == "update") {
        this.addGroupValue = data.user_name;
        this.mac = data.mac;
        this.group_tit = "编辑员工名称";
        this.datas = data;
        this.GroupVisible = true;
      } else if (e == "move") {
        this.gronpValue = "";
        this.mac = data.mac;
        this.group_tit = "移至分组";
        this.datas = data;
        this.GroupVisible = true;
      } else if (e == "delete") {
        const user_name = sessionStorage.getItem("user_name");
        const mac = data.mac;
        let macSplit = mac.replace(/-/g, "");
        let url = `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=uninstall`;
        http({
          method: "GET",
          url: url,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
          }
        })
          .then(res => {
            if (res.code == 0) {
              let d = 0;
              let q = 0;
              const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
              for (let s = 0; s < this.poples.length; s++) {
                if (this.poples[s].id == data.id) {
                  d = s;
                }
              }
              for (let s = 0; s < dataGroup.server; s++) {
                if (dataGroup.server[s].id == data.id) {
                  q = s;
                }
              }
              this.poples.splice(d);
              dataGroup.server.splice(q);
              sessionStorage.setItem("dataGroup", JSON.stringify(dataGroup));
              this.$message({ message: "卸载成功", type: "success" });
            } else {
              this.$message({
                showClose: true,
                message: data.msg,
                type: "error"
              });
            }
          })
          .catch(res => {
            console.log(res);
          });
      }
    },
    addGroupOk() {
      const user_name = sessionStorage.getItem("user_name");
      if (this.group_state == "add") {
        let json = {
          user: user_name,
          group_name: this.addGroupValue,
          type: 7
        };
        if (this.global.ws.readyState === 1) {
          this.global.ws.send(JSON.stringify(json));
        } else {
          this.global.ws.onopen = () => {
            this.global.ws.send(JSON.stringify(json));
          };
        }
        this.global.ws.onmessage = params => {
          let data = JSON.parse(params.data);
          if (data.code == 0) {
            let ids = Math.ceil(Math.random() * 100000000000);
            this.options.push({
              group_name: this.addGroupValue,
              id: ids,
              owner: "nmtest1034"
            });
            const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
            dataGroup.group = this.options;
            sessionStorage.setItem("dataGroup", JSON.stringify(dataGroup));
            this.$message({ message: "添加成功", type: "success" });
            this.GroupVisible = false;
            this.optionsChange(ids);
            //setTimeout(this.optionsChange(ids), 1000);
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "error"
            });
            this.GroupVisible = false;
          }
        };
      } else if (this.group_state == "updateGroupName") {
        const user_name = sessionStorage.getItem("user_name");
        let json = {
          user: user_name,
          type: 6,
          newName: this.addGroupValue,
          oldName: this.oldName
        };
        if (this.global.ws.readyState === 1) {
          this.global.ws.send(JSON.stringify(json));
        } else {
          this.global.ws.onopen = () => {
            this.global.ws.send(JSON.stringify(json));
          };
        }
        this.global.ws.onmessage = params => {
          let data = JSON.parse(params.data);
          if (data.code == 0) {
            this.datas.user_name = this.addGroupValue;
            const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
            for (let s of this.options) {
              if (s.id == this.cursonGroup) {
                s.group_name = this.addGroupValue;
              }
            }
            for (let e of dataGroup.group) {
              if (e.id == this.cursonGroup) {
                e.group_name = this.addGroupValue;
              }
            }
            for (let f of dataGroup.server) {
              if (f.group_name == this.oldName) {
                f.group_name = this.addGroupValue;
              }
            }
            sessionStorage.setItem("dataGroup", JSON.stringify(dataGroup));
            this.$message({ message: "编辑分组名称成功", type: "success" });
            this.GroupVisible = false;
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "error"
            });
            this.GroupVisible = false;
          }
        };
      } else if (this.group_state == "update") {
        const user_name = sessionStorage.getItem("user_name");
        let json = {
          user: user_name,
          type: 16,
          newName: this.addGroupValue,
          mac: this.mac
        };
        if (this.global.ws.readyState === 1) {
          this.global.ws.send(JSON.stringify(json));
        } else {
          this.global.ws.onopen = () => {
            this.global.ws.send(JSON.stringify(json));
          };
        }
        this.global.ws.onmessage = params => {
          let data = JSON.parse(params.data);
          if (data.code == 0) {
            this.datas.user_name = this.addGroupValue;
            const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
            for (let s of this.poples) {
              if (s.id == this.datas.id) {
                s.host_name = this.addGroupValue;
              }
            }
            console.log(dataGroup.server);
            for (let e of dataGroup.server) {
              if (e.id == this.datas.id) {
                e.user_name = this.addGroupValue;
              }
            }
            sessionStorage.setItem("dataGroup", JSON.stringify(dataGroup));
            this.$message({ message: "编辑成功", type: "success" });
            this.GroupVisible = false;
            if (this.$route.path == "/yggk") {
              this.$router.replace("/yggk");
            }
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "error"
            });
            this.GroupVisible = false;
          }
        };
      } else if (this.group_state == "move") {
        const user_name = sessionStorage.getItem("user_name");
        let json = {
          user: user_name,
          type: 10,
          newName: this.gronpValue,
          mac: this.mac
        };
        if (this.global.ws.readyState === 1) {
          this.global.ws.send(JSON.stringify(json));
        } else {
          this.global.ws.onopen = () => {
            this.global.ws.send(JSON.stringify(json));
          };
        }
        this.global.ws.onmessage = params => {
          let data = JSON.parse(params.data);
          if (data.code == 0) {
            this.datas.group_name = this.gronpValue;
            const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
            for (let s of dataGroup.server) {
              if (s.id == this.datas.id) {
                s.group_name = this.gronpValue;
              }
            }
            sessionStorage.setItem("dataGroup", JSON.stringify(dataGroup));
            this.$message({ message: "移至成功", type: "success" });
            this.GroupVisible = false;
            this.optionsChange(this.cursonGroup);
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "error"
            });
            this.GroupVisible = false;
          }
        };
      }
    },
    onGronpClose() {
      this.GroupVisible = false;
    },
    onLiOver(event, e) {
      event.stopPropagation();
      for (let sew of this.poples) {
        sew.check = false;
      }
      e.check = true;
    },
    onClose() {
      this.dialogVisible = false;
    },
    handleClick() {
      if (!this.ryCheck) {
        this.dialogVisible = true;
        return false;
      }
      if (this.activeName == "yggk") {
        this.classet = "gk";
        this.$router.replace("/yggk");
      } else if (this.activeName == "lsjl") {
        this.classet = "lx";
        this.$router.replace("/lsjl_lx");
      } else if (this.activeName == "ssjk") {
        this.classet = "pm";
        this.$router.replace("/ssjk_pm");
      } else if (this.activeName == "xwsj") {
        this.classet = "wz";
        this.$router.replace("/xwsj_wz");
      } else if (this.activeName == "xtxx") {
        this.classet = "jc";
        this.$router.replace("/xtxx_jc");
      }
    },
    onLsjl(e) {
      if (!this.ryCheck) {
        this.dialogVisible = true;
        return false;
      }
      if (e == "lx") {
        this.classet = "lx";
        this.$router.replace("/lsjl_lx");
      } else if (e == "jt") {
        this.classet = "jt";
        this.$router.replace("/lsjl_jt");
      } else if (e == "lt") {
        this.classet = "lt";
        this.$router.replace("/lsjl_lt");
      } else if (e == "wj") {
        this.classet = "wj";
        this.$router.replace("/lsjl_wj");
      }
    },
    onSsjk(e) {
      if (!this.ryCheck) {
        this.dialogVisible = true;
        return false;
      }
      if (e == "pm") {
        this.classet = "pm";
        this.$router.replace("/ssjk_pm");
      } else if (e == "dp") {
        this.classet = "dp";
        this.$router.replace("/ssjk_dp");
      }
    },
    onXwsj(e) {
      if (!this.ryCheck) {
        this.dialogVisible = true;
        return false;
      }
      if (e == "wz") {
        this.classet = "wz";
        this.$router.replace("/xwsj_wz");
      } else if (e == "rj") {
        this.classet = "rj";
        this.$router.replace("/xwsj_rj");
      } else if (e == "jq") {
        this.classet = "jq";
        this.$router.replace("/xwsj_jq");
      } else if (e == "kg") {
        this.classet = "kg";
        this.$router.replace("/xwsj_kg");
      }
    },
    onXtxx(e) {
      if (!this.ryCheck) {
        this.dialogVisible = true;
        return false;
      }
      if (e == "jc") {
        this.classet = "jc";
        this.$router.replace("/xtxx_jc");
      } else if (e == "xt") {
        this.classet = "xt";
        this.$router.replace("/xtxx_xt");
      } else if (e == "rj") {
        this.classet = "rj";
        this.$router.replace("/xtxx_rj");
      } else if (e == "yj") {
        this.classet = "yj";
        this.$router.replace("/xtxx_xx");
      }
    },
    ygInfo(e) {
      if (e.is_online == 0) {
        this.$message({
          showClose: true,
          message: "当前主机不在线",
          type: "error"
        });
        return false;
      }
      this.ryCheck = true;
      for (let df of this.poples) {
        df.click = false;
      }
      e.click = true;
      this.classet = "gk";
      this.activeName = "yggk";
      sessionStorage.setItem("mac", e.mac);
      this.$router.push({
        path: "/yggk",
        query: {
          name: e.user_name,
          mac: e.mac,
          owner: e.owner,
          is_online: e.is_online
        }
      });
    }
  }
};
</script>
<style scoped>
.body {
  background: #f2f2f2;
}
.body /deep/.el-dialog {
  border: 4px solid #e9e9e9;
  position: relative;
}
.body /deep/.el-dialog .wxts_close {
  position: absolute;
  padding: 3px 8px 5px 11px;
  background: #e9e9e9;
  right: 0px;
  top: 0px;
  color: #a7a7a7;
  font-size: 22px;
  border-bottom-left-radius: 20px;
  cursor: pointer;
}
.cons {
  padding: 24px;
  display: flex;
  flex-wrap: wrap;
}
.cons .cons_username {
  height: 114px;
  width: 303px;
  margin-right: 24px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}
.cons .cons_username .cons_pople {
  text-align: center;
  margin-right: 57px;
}
.cons .cons_username .cons_pople .cons_pople_online {
  font-size: 14px;
  font-weight: 400;
  color: rgba(68, 68, 68, 1);
  margin-top: 2px;
}
.cons .cons_username .cons_pople .cons_pople_onlineSum {
  font-size: 20px;
  font-weight: bold;
  color: rgba(68, 68, 68, 1);
  margin-top: 3px;
}
.cons .cons_username .cons_catenate {
  text-align: center;
}
.cons .cons_username .cons_catenate .cons_catenate_online {
  font-size: 14px;
  font-weight: 400;
  color: rgba(68, 68, 68, 1);
  margin-top: 2px;
}
.cons .cons_username .cons_catenate .cons_catenate_onlineSum {
  font-size: 16px;
  font-weight: 400;
  color: rgba(96, 203, 131, 1);
  margin-top: 3px;
}
.cons .cons_username .cons_catenate .cons_catenate_relink {
  border: 1px solid #ff9b80;
  font-size: 13px;
  font-weight: 400;
  color: rgba(242, 131, 101, 1);
  padding: 7px 16px;
  border-radius: 8px;
  cursor: pointer;
}
.cons .cons_username .cons_catenate .cons_catenate_relink img {
  vertical-align: middle;
  margin-right: 5px;
  margin-top: -5px;
}
.cons .cons_deed {
  width: calc(100vw - 442px);
  height: 114px;
  background: #fff;
  border-radius: 8px;
  padding: 0 20px;
}
.cons .cons_deed /deep/.el-tabs {
  padding-top: 12px;
}
.cons .cons_deed /deep/.el-tabs__item {
  font-size: 16px;
  font-weight: bold;
  color: #464646;
}
.cons .cons_group {
  margin-top: 24px;
  height: calc(100vh - 252px);
  width: 303px;
  margin-right: 24px;
  background: #fff;
  border-radius: 8px;
}
.cons .cons_group .cons_group_header {
  display: flex;
  padding: 21px 0px;
  text-align: center;
  align-items: center;
  justify-content: center;
}
.cons .cons_group .cons_group_header .cons_addGroup {
  cursor: pointer;
  margin-right: 90px;
}
.cons .cons_group .cons_group_header .cons_addGroup img {
  vertical-align: middle;
  margin-top: -5px;
  margin-right: 4px;
}
.cons .cons_group .cons_group_header .cons_online {
  cursor: pointer;
}
.cons .cons_group .cons_group_header .cons_online img {
  vertical-align: middle;
  margin-top: -5px;
  margin-right: 4px;
}
.cons .cons_group .cons_group_con {
  text-align: center;
}
.cons .cons_group .cons_group_con /deep/.el-select {
  display: block;
}
.cons .cons_group .cons_group_con /deep/.el-input__inner {
  background-color: #2879fd;
  border-radius: 8px;
  color: #fff;
}
.cons .cons_group .cons_group_con /deep/.el-input__inner::placeholder {
  color: #fff;
}
.cons .cons_group .cons_group_footer {
  margin-top: 20px;
  height: calc(100vh - 400px);
  overflow: auto;
}
.cons .cons_group .cons_group_footer /deep/.el-dropdown {
  margin-top: 3px;
}
.cons .cons_group .cons_group_footer ul li {
  padding: 10px 0px;
  border-bottom: 1px solid #e8e8e8;
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  color: rgba(68, 68, 68, 1);
  display: flex;
  justify-content: space-between;
}
.cons .cons_group .cons_group_footer ul li.on {
  color: #2878ff;
}
.cons .cons_group .cons_group_footer ul li img {
  vertical-align: middle;
  margin-top: -5px;
  margin-right: 12px;
}
.cons .cons_group .cons_group_footer ul li:hover {
  color: #2878ff;
}
.cons .cons_content {
  margin-top: 24px;
  height: calc(100vh - 252px);
  width: calc(100vw - 402px);
  text-align: center;
}
.wxts {
  text-align: center;
  padding-bottom: 40px;
}
.wxts .p_wxp1 {
  font-size: 20px;
  font-weight: bold;
  color: rgba(126, 126, 126, 1);
}
.wxts .p_wxp1 img {
  vertical-align: middle;
  margin-right: 5px;
  margin-top: -5px;
}
.wxts .p_wxp2 {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(164, 164, 164, 1);
}
.tab_lsjl {
  display: flex;
  align-items: center;
}
.tab_lsjl div {
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 30px;
  padding-bottom: 23px;
  font-size: 14px;
  font-weight: bold;
  color: #777777;
  cursor: pointer;
}
.tab_lsjl div.on {
  color: #2878ff;
  background: url("../assets/sxj_icon.png") no-repeat center bottom;
}
.tab_lsjl div img {
  vertical-align: middle;
  margin-top: -5px;
  margin-right: 5px;
}
</style>
